import CustomeHelmet from 'pages/components/CustomeHelmet'
import React, { useEffect, useState } from 'react'
function AppStore() {
     const [data, setData] = useState([]);
     const [loading, setLoading] = useState(true);

       useEffect(() => {
         const fetchData = async () => {
           try {
             const response = await fetch('/assets/AppStore.json');
             const Data = await response.json();
             setData(Data);
           } catch (error) {
             console.error('Error loading clients data:', error);
           } finally {
             setLoading(false);
           }
         };
         fetchData();
       }, []);
  if (loading) {
    return <div>Loading Apps...</div>;
  }
   const handleDownload = (url ,AppName) => {
    const downloadUrl = {url}; 
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `${AppName}.exe`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <>
    <CustomeHelmet pageName="AppStrore" />
          <main>
            <section class="app-section" data-theme="dark">
            <div class="section-header">
                <h2 class="section-title">Store</h2>
            </div>
         <div className='app-container'>  <div class="app-grid">
               

                {/* <div class="app-card">
                    <div class="app-image">
                      <img src={logo} alt="logo" width='100px' />
                    </div>
                    <div class="app-content">
                        <h3 class="app-title">Enterprise Connect</h3>
                        <p class="app-date">Date : 8 / 2025</p>
                        <p class="app-description">Unified communications platform with video conferencing and messaging.</p>
                        <div class="app-footer">
                            <div class="app-version"> 
                                <span>v20.16.50</span>
                            </div>
                            <button class="app-download">download</button>
                        </div>
                    </div>
                </div> */}
                 {data.map((app) => (
                <div className="app-card" key={app["NO."]}>
                  <div className="app-image">
                    <img 
                      src={app.CompanyLogo} 
                      alt={app.AppName} 
                      width='100px' 
                    />
                  </div>
                  <div className="app-content">
                    <h3 className="app-title">{app.AppName}</h3>
                    <p className="app-date">Date : {app.Date}</p>
                    <p className="app-description">{app.Description}</p>
                    <div className="app-footer">
                      <div className="app-version"> 
                        <span>{app.version}</span>
                      </div>
                      <div className="app-download" onClick={() =>  handleDownload(app.url , app.AppName)}>Download</div>
                    </div>
                  </div>
                </div>
              ))}

            </div>
            </div> 
        </section>
        </main>
    </>
  )
}

export default AppStore
